<script>
    export default {
        data() {
            return {
                stackedColors: [
                    '#18BDCB', // blue
                    '#7DD0A9', // green
                    '#FFE97E', // yellow
                    '#FFB375', // orange
                    '#FF5D67', // red
                    '#B72424', // deep red
                    '#D42488', // purple
                    '#FFB1DD', // pink
                    '#C2A9B7', // mauve
                    '#757CE9', // voilet
                ],

                dataStyling : {
                    order: 2,
                },

                defaultOptions : {
                    tooltips: {
                        backgroundColor: '#0E0F20',
                        titleFontFamily: 'proxima-nova',
                        titleFontSize: 14,
                        titleSpacing: 4,
                        bodyFontFamily: 'proxima-nova',
                        bodyFontSize: 14,
                        bodySpacing: 4,
                        cornerRadius: 0,
                        xPadding: 8,
                        yPadding: 8,
                        displayColors: false
                    },
                    responsive: true,
                    responsiveAnimationDuration: 1000,
                    maintainAspectRatio: true,
                    aspectRatio: 1.4
                },

                defaultTargetDataStyling: {
                    spanGaps: false,
                    fill: false,
                    order: 0,
                },

                targetChartType: 'line'
            }
        },

        watch: {
            'dataStyling': function (newData, oldData) {
                if (newData !== oldData) {
                    this.rerenderChart()
                }
            },

            'chartData': function (newData, oldData) {
                if (newData !== oldData) {
                    this.rerenderChart()
                }
            },
        },

        computed: {
            hasTargets() {
                if (this.targetDataset) {
                    return this.targetDataset.length > 0
                }

                return this.chartData.datasets.findIndex(dataset => dataset.target) > -1
            },

            isDarkScheme() {
                return this.scheme === 'dark'
            },

            isStacked() {
                if (!this.options.scales) {
                    return false
                }

                let xAxesStacked = this.options.scales.xAxes.find(x => x.stacked)
                let yAxesStacked = this.options.scales.yAxes.find(y => y.stacked)

                return xAxesStacked || yAxesStacked ? true : false
            },

            totalTargets() {
                return this.chartData.datasets.filter(dataset => dataset.target).length || 0
            },
        },

        mounted () {
            // this.createChart()
        },

        methods: {
            buildSingleDimensionChartData() {
                let datasetIndex = 0
                let labels = []
                let datasets = [
                    {data: []}
                ]

                if (Array.isArray(this.chartData.datasets)) {
                    for (const dataset of this.chartData.datasets) {
                        if (!dataset.target) {
                            labels.push(dataset.label)
                            datasets[datasetIndex].data.push(dataset.data[datasetIndex])
                        }
                    }
                }

                this.chartData.datasets = datasets
                this.chartData.labels = labels
            },

            createChart() {
                let datasets = this.chartData.datasets.map(dataset => {
                    if (dataset.target) {
                        dataset = {
                            type: this.targetChartType,
                            ...dataset,
                            ...this.defaultTargetDataStyling,
                            ...this.targetDataStyling,
                        }
                    } else {
                        dataset = {
                            ...dataset,
                            ...this.dataStyling,
                        }
                    }

                    return dataset
                })

                this.renderChart(
                    {
                        isInverted: this.chartData.isInverted,
                        labels: this.chartData.labels,
                        datasets: datasets
                    },
                    {
                        ...this.defaultOptions,
                        ...this.options,
                    }
                )
            },

            createCustomLegend(legendPosition) {
                this.htmlLegend = this.generateLegend()

                if (legendPosition === 'left') {
                    $(this.$refs.canvas).before('<div class="customLegend"></div>')
                } else {
                    $(this.$refs.canvas).after('<div class="customLegend"></div>')
                }

                let customLegend = $(this.$refs.canvas).parent().find('.customLegend')

                customLegend.html(this.htmlLegend)

                let legendItems = customLegend.find('li')

                for (const item of legendItems) {
                    item.addEventListener("click", this.legendClickCallback, false)
                }
            },

            createStackedChart() {
                let colorIndex = {}

                this.chartData.datasets.forEach((dataset, index) => {
                    if (!dataset.target) {
                        colorIndex[dataset.label] = this.stackedColors[index]
                        dataset.backgroundColor = this.stackedColors[index]
                        dataset.borderColor = this.stackedColors[index]
                    }
                })

                this.chartData.datasets.forEach((dataset, index) => {
                    if (dataset.target) {
                        dataset.backgroundColor = colorIndex[dataset.label]
                        dataset.pointBackgroundColor = colorIndex[dataset.label]
                        dataset.pointBorderColor = colorIndex[dataset.label]
                    }
                })

                this.createChart()
            },

            legendClickCallback(event) {
                event = event || window.event

                let target = event.target || event.srcElement

                while (target.nodeName !== 'LI') {
                    target = target.parentElement
                }

                const parent = target.parentElement
                const chartId = parseInt(parent.classList[0].split("-")[0], 10)
                const chart = Chart.instances[chartId]
                const index = Array.prototype.slice.call(parent.children).indexOf(target) + this.totalTargets
                const legendItem = chart.legend.legendItems[index]

                chart.legend.legendItems.filter(item => item.text === legendItem.text).forEach(item => {
                    chart.legend.options.onClick.call(chart, event, item);
                })

                $(target).toggleClass('opacity-25')
            },

            rerenderChart() {
                if (this.$data._chart) {
                    this.$data._chart.destroy()
                    this.$emit('chart:destroy')
                }

                if (this.isStacked) {
                    this.createStackedChart()
                } else {
                    this.createChart()
                }
                this.$emit('chart:render')
            },
        }
    }
</script>